import ChatNoteInput from './ChatNoteInput';
export default ChatNoteInput;
